export const LoadSureSelect = (props: {
  label: string;
  value: string | number | null | undefined;
  onChange:
    | ((e: { target: { value: string } }) => void)
    | ((e: { target: { value: number } }) => void);
  required: boolean;
  options: { id: number | string; name: string }[];
}) => {
  return (
    <div class="my-2 relative">
      <label class="absolute -top-[11px] left-2 bg-white px-1 text-sm font-medium text-gray-700">
        {props.label}
        {props.required && <span class="text-[#b00020]"> *</span>}
      </label>
      <select
        class="w-full px-3 py-2 border-2 border-[#80b6cf] rounded-md shadow-xs focus:outline-hidden focus:border-[#123b50] hover:border-[#123b50]"
        value={props.value ?? ''}
        // @ts-expect-error onChange types in JSX
        onChange={props.onChange}
      >
        {props.options.map((c) => (
          <option value={c.id}>{c.name}</option>
        ))}
      </select>
    </div>
  );
};
